// The demo "database": the seed DB held in memory and mirrored to localStorage
// so a visitor's edits survive a reload (the "client storage" the demo runs on).
// Every mutation goes through getDb() + persist(); there is no server.

import { buildSeed, type DemoDb } from "./seed";

const STORAGE_KEY = "hash.demo.v1";

let db: DemoDb | null = null;

function load(): DemoDb {
  if (db) return db;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      db = JSON.parse(raw) as DemoDb;
      return db;
    }
  } catch {
    /* corrupt or unavailable storage — fall through to a fresh seed */
  }
  db = buildSeed();
  persist();
  return db;
}

/** The live demo DB. Mutate it in place, then call persist(). */
export function getDb(): DemoDb {
  return load();
}

/** Flush the in-memory DB to localStorage. */
export function persist(): void {
  if (!db) return;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(db));
  } catch {
    /* storage full or blocked (private mode) — the in-memory copy still works */
  }
}

/** Reseed from scratch (relative to today) and persist. The "Reset demo data". */
export function resetDemo(): void {
  db = buildSeed();
  persist();
}
